<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="List Of Abbreviations">
<p class="fm_h" id="abb"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><a href="#/text/9780253053770_Contents#rabb">LIST OF ABBREVIATIONS</a></span></p>
<p class="abb">Andriamirado, <i>Il s’appelait</i>: Sennen Andriamirado, <i>Il s’appelait Sankara: Chronique d’une mort violente</i></p>
<p class="abb">Bamouni, <i>Burkina Faso</i>: Babou Paulin Bamouni, <i>Burkina Faso: Processus de la Révolution</i></p>
<p class="abb">CDR: Comité de la Défense de la Révolution (Revolutionary Defense Committee)</p>
<p class="abb">CEAO: Communauté Economique de l’Afrique de l’Ouest (Economic Community of West Africa)</p>
<p class="abb">CMRPN: Comité Militaire de redressement pour le Progès National (Military Committee for Redressement and National Progress)</p>
<p class="abb">CNEC: Centre National d’Entrainement Commandos (National Commando Training Center)</p>
<p class="abb">CNR: Conseil National de la Révolution (National Council of the Revolution)</p>
<p class="abb">CSB: Confédération syndicale Burkinabé (Burkinabé Union Confederation)</p>
<p class="abb">CSV: Confédération syndicale Voltaïque (Voltaic Union Confederation)</p>
<p class="abb">CSP: Conseil du Salut du Peuple (Council of Popular Salvation)</p>
<p class="abb">DOP: Discours d’Orientation Populaire (Political Orientation Speech)</p>
<p class="abb">FESPACO: Festival Panafricain du cinéma de Ouagadougou (Pan-African film festival of Ouagadougou)</p>
<p class="abb">FPV: Front Populaire Voltaïque (Voltaic Popular Front)</p>
<p class="abb">GCB: Group des Communistes Burkinabé (Burkinabé Communists Group)</p>
<p class="abb">GOB: Government of Burkina Faso</p>
<p class="abb">GOF: Government of France</p>
<p class="abb">GOUV: Government of Upper Volta</p>
<p class="abb">IMF: International Monetary Fund</p>
<p class="abb">Jaffré, <i>Biographie</i>: Bruno Jaffré, <i>Biographie de Thomas Sankara: La Patrie ou la Mort</i></p>
<p class="abb">LIPAD: Ligue Patriotique pour le développement (Patriotic league for development)</p>
<p class="abb">Martens, <i>Sankara, Compaoré</i>: Ludo Martens, <i>Sankara, Compaoré et la revolution Burkinabé</i></p>
<p class="abb"><span class="right_1" epub:type="pagebreak" id="page_xii" title="xii">MLN: Mouvement de Libération Nationale (National Liberation Movement)</span></p>
<p class="abb">NGO: Nongovernmental Organizations</p>
<p class="abb">OAU: Organization of African Unity</p>
<p class="abb">OCV: Organisation Communiste Voltaïque (Voltaic Communist Organization)</p>
<p class="abb">ONSL: Organisation Nationale des Syndicats Libres (National Organization of Free Trade Unions)</p>
<p class="abb">OPEC: Organization of Petroleum Exporting Countries</p>
<p class="abb">PAI: Parti Africain de l’Indépendance (African Independence Party)</p>
<p class="abb">PMK: Prytanée Militaire du Kadiogo (Military Academy of Kadiogo)</p>
<p class="abb">PPD: Programme populaire de développement (Popular Development Program)</p>
<p class="abb">PCRV: Parti Communiste Révolutionnaire Voltaïque (Voltaic Revolutionary Communist Party)</p>
<p class="abb">RDA: Rassemblement Démocratique Africain (African Democratic Rally)</p>
<p class="abb">RDP: Révolution Démocratique et Populaire (Democratic and Popular Revolution)</p>
<p class="abb">Sankara, <i>Oser Inventer</i>: Thomas Sankara, <i>Oser Inventer l’avenir, la Parole de Sankara</i></p>
<p class="abb">Sawadogo, <i>Le Président Thomas Sankara</i>: Alfred Sawadogo, <i>Le Président Thomas Sankara, Chef de la revolution burkinabé: 1983–1987 Portrait</i></p>
<p class="abb">SNEAHV: Syndicat National des Enseignants Africains de Haute-Volta (National Union of African Teachers of Upper Volta)</p>
<p class="abb">Somé, <i>Thomas Sankara</i>: Valère Somé, <i>Thomas Sankara: L’Espoir Assassiné</i></p>
<p class="abb">TPR: Tribunaux Populaires de la revolution (Popular Revolutionary Tribunals)</p>
<p class="abb">UCB: Union des Communistes Burkinabé (Union of Burkinabé Communists)</p>
<p class="abb">UFB: Union des femmes Burkinabé (Union of Burkinabé Women)</p>
<p class="abb">ULC: Union de Lutte Communiste (Union of Communist Struggle)</p>
<p class="abb">ULCR: Union de Lutte Communiste Reconstruite (Union of Communist Struggle—Reconstructed)</p>
<p class="abb">UNAB: Union nationale des anciens du Burkina (National Union of Elders of Burkina)</p>
<p class="abb">UNPB: Union national des paysans du Burkina (National Peasants Union of Burkina)</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253053770_Abbreviations.vue?1b056fde